import { css } from '@emotion/react';

export default () => {
  return {
    link: css`
      display: block;
      font-weight: 700;
      transition: color 0.5s;
      margin-left: -10px !important;
      &:hover {
        text-decoration: underline;
      }
    `,
  };
};